import React from 'react';

export default function LegalStructure() {
  return (
    <section className="w-full bg-gray-950 text-white py-20 px-6 md:px-10">
      <div className="max-w-5xl mx-auto space-y-14">

        {/* Section Header */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Legal & Structure</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            M2T is structured for global operations, clean equity, and future-proof compliance — starting lean and scaling legally across regions.
          </p>
        </div>

        {/* Legal Setup Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-300 text-sm">

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">🏢 Company Registration</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Primary entity in Dubai Free Zone (global fintech base)</li>
              <li>Secondary registration in India (operations & legal)</li>
              <li>Founder retains 75% equity post-round</li>
            </ul>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">🛡️ Compliance Strategy</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>GDPR-compliant user onboarding and SmartCard ID</li>
              <li>Role-based verification pipeline (non-KYC to KYC)</li>
              <li>Privacy-first data policy built into infra</li>
            </ul>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">📑 Advisory & Legal Support</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Global advisory pool includes legal, fintech, and regulatory experts</li>
              <li>Targeting legal sandbox access in India & UAE</li>
            </ul>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">🔮 Future Licensing Plans</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>SEBI (India) platform/marketplace registration (2026 goal)</li>
              <li>Signal publishing & strategy licensing modules</li>
              <li>Modular compliance layers for global expansion</li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
}
